import { useEffect, useState } from 'react';
import { enhancedSitemapService } from '@/services/enhancedSitemapService';

const Sitemap = () => {
  const [sitemapContent, setSitemapContent] = useState<string>('');

  useEffect(() => {
    // Remove all styling and set document to plain XML mode
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    document.body.style.fontFamily = 'monospace';
    document.body.style.whiteSpace = 'pre';
    document.body.style.fontSize = '12px';
    document.body.style.lineHeight = '1.4';
    document.body.style.color = '#000';
    document.body.style.backgroundColor = '#fff';
    
    // Hide all other elements
    const allElements = document.querySelectorAll('*:not(#root):not(#root *)');
    allElements.forEach(el => {
      if (el !== document.body && el !== document.documentElement) {
        (el as HTMLElement).style.display = 'none';
      }
    });
    
    return () => {
      // Reset styles on cleanup
      document.body.style.cssText = '';
    };
  }, []);

  useEffect(() => {
    const generateSitemap = async () => {
      try {
        const content = await enhancedSitemapService.generateSitemap();
        setSitemapContent(content);
      } catch (error) {
        console.error('Failed to generate sitemap:', error);
        // Fallback sitemap
        const today = new Date().toISOString().split('T')[0];
        setSitemapContent(`<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
  <url><loc>https://seniorthrive.com/</loc><lastmod>${today}</lastmod><changefreq>weekly</changefreq><priority>1.0</priority></url>
  <url><loc>https://seniorthrive.com/features</loc><lastmod>${today}</lastmod><changefreq>monthly</changefreq><priority>0.9</priority></url>
  <url><loc>https://seniorthrive.com/pricing</loc><lastmod>${today}</lastmod><changefreq>monthly</changefreq><priority>0.9</priority></url>
  <url><loc>https://seniorthrive.com/older-adults</loc><lastmod>${today}</lastmod><changefreq>monthly</changefreq><priority>0.8</priority></url>
  <url><loc>https://seniorthrive.com/thrivefamily</loc><lastmod>${today}</lastmod><changefreq>monthly</changefreq><priority>0.8</priority></url>
  <url><loc>https://seniorthrive.com/family-caregiver-tools</loc><lastmod>${today}</lastmod><changefreq>monthly</changefreq><priority>0.7</priority></url>
  <url><loc>https://seniorthrive.com/caregiver-coordination</loc><lastmod>${today}</lastmod><changefreq>monthly</changefreq><priority>0.7</priority></url>
  <url><loc>https://seniorthrive.com/about-seniorthrive</loc><lastmod>${today}</lastmod><changefreq>monthly</changefreq><priority>0.7</priority></url>
  <url><loc>https://seniorthrive.com/support/faq</loc><lastmod>${today}</lastmod><changefreq>weekly</changefreq><priority>0.7</priority></url>
  <url><loc>https://seniorthrive.com/blog</loc><lastmod>${today}</lastmod><changefreq>weekly</changefreq><priority>0.7</priority></url>
  <url><loc>https://seniorthrive.com/stories</loc><lastmod>${today}</lastmod><changefreq>monthly</changefreq><priority>0.6</priority></url>
  <url><loc>https://seniorthrive.com/contact</loc><lastmod>${today}</lastmod><changefreq>monthly</changefreq><priority>0.6</priority></url>
  <url><loc>https://seniorthrive.com/professional-network</loc><lastmod>${today}</lastmod><changefreq>monthly</changefreq><priority>0.6</priority></url>
  <url><loc>https://seniorthrive.com/professionals/directory</loc><lastmod>${today}</lastmod><changefreq>weekly</changefreq><priority>0.6</priority></url>
  <url><loc>https://seniorthrive.com/partners</loc><lastmod>${today}</lastmod><changefreq>monthly</changefreq><priority>0.5</priority></url>
  <url><loc>https://seniorthrive.com/sponsor-older-adults</loc><lastmod>${today}</lastmod><changefreq>monthly</changefreq><priority>0.5</priority></url>
  <url><loc>https://seniorthrive.com/conversation-guide</loc><lastmod>${today}</lastmod><changefreq>monthly</changefreq><priority>0.5</priority></url>
  <url><loc>https://seniorthrive.com/aging-in-place</loc><lastmod>${today}</lastmod><changefreq>monthly</changefreq><priority>0.5</priority></url>
  <url><loc>https://seniorthrive.com/privacy</loc><lastmod>${today}</lastmod><changefreq>yearly</changefreq><priority>0.3</priority></url>
  <url><loc>https://seniorthrive.com/terms</loc><lastmod>${today}</lastmod><changefreq>yearly</changefreq><priority>0.3</priority></url>
</urlset>`);
      }
    };

    generateSitemap();
  }, []);

  return (
    <pre style={{ 
      margin: 0,
      padding: 0,
      fontFamily: 'monospace',
      fontSize: '12px',
      lineHeight: '1.4',
      whiteSpace: 'pre',
      color: '#000',
      backgroundColor: '#fff',
      border: 'none',
      outline: 'none'
    }}>
      {sitemapContent}
    </pre>
  );
};

export default Sitemap;